var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie-animation',{staticStyle:{"position":"fixed","top":"0","left":"0","pointer-events":"none","z-index":"1000"},attrs:{"path":_vm.path,"loop":false,"autoPlay":false,"speed":1},on:{"AnimControl":_vm.setAnimController}})}
var staticRenderFns = []

export { render, staticRenderFns }